import React from "react";
import { Search, Briefcase, MapPin, FileText, User, Eye } from "lucide-react";

const WorkspaceTable = ({ data, onRowClick }) => {
  return (
    <div className="bg-white rounded-b-xl shadow border border-slate-200 overflow-hidden">
      <div className="overflow-x-auto">
        <table className="w-full text-left border-collapse">
          <thead className="bg-slate-50 border-b border-slate-200">
            <tr>
              <th className="px-6 py-4 text-xs font-bold text-slate-500 uppercase tracking-wider w-[25%]">
                Cửa hàng / Workspace
              </th>
              <th className="px-6 py-4 text-xs font-bold text-slate-500 uppercase tracking-wider w-[15%]">
                Terminal ID
              </th>
              <th className="px-6 py-4 text-xs font-bold text-slate-500 uppercase tracking-wider w-[25%]">
                Địa chỉ kinh doanh
              </th>
              <th className="px-6 py-4 text-xs font-bold text-slate-500 uppercase tracking-wider w-[15%]">
                Thông tin pháp lý
              </th>
              <th className="px-6 py-4 text-xs font-bold text-slate-500 uppercase tracking-wider w-[15%]">
                Chủ sở hữu
              </th>
              <th className="px-4 py-4 text-xs font-bold text-slate-500 uppercase tracking-wider w-[5%] text-center">
                Hành động
              </th>
            </tr>
          </thead>
          <tbody className="divide-y divide-slate-200">
            {data.length > 0 ? (
              data.map((shop, index) => (
                <tr
                  key={shop.terminalID || index}
                  onClick={() => onRowClick(shop)}
                  className="hover:bg-blue-50/50 transition-colors cursor-pointer group"
                >
                  {/* Cột 1: Tên Shop */}
                  <td className="px-6 py-4 align-top">
                    <div className="flex flex-col">
                      <div className="flex items-center mb-1">
                        <span
                          className="font-semibold text-slate-900 line-clamp-2 text-sm"
                          title={shop.workspaceName}
                        >
                          {shop.workspaceName || shop.userName}
                        </span>
                      </div>
                      {shop.businessType && (
                        <div className="flex items-center gap-1.5 text-xs text-slate-600 bg-slate-100 w-fit px-2 py-0.5 rounded border border-slate-200 mt-1">
                          <Briefcase size={10} className="text-slate-500" />
                          <span
                            className="line-clamp-1 max-w-[180px]"
                            title={shop.businessType}
                          >
                            {shop.businessType}
                          </span>
                        </div>
                      )}
                    </div>
                  </td>

                  {/* Cột 2: Terminal ID */}
                  <td className="px-6 py-4 align-top">
                    <div className="text-xs font-mono font-bold bg-blue-50 text-blue-700 px-2 py-1 rounded border border-blue-100 w-fit">
                      {shop.terminalID}
                    </div>
                  </td>

                  {/* Cột 3: Địa chỉ */}
                  <td className="px-6 py-4 align-top">
                    <div className="flex items-start gap-2">
                      <MapPin size={14} className="text-slate-400 mt-0.5 flex-shrink-0" />
                      <span className="text-sm text-slate-700 font-medium line-clamp-2" title={shop.merchantAddress}>
                        {shop.merchantAddress || "---"}
                      </span>
                    </div>
                  </td>

                  {/* Cột 4: Pháp lý */}
                  <td className="px-6 py-4 align-top">
                    {shop.businessRegistrationNumber ? (
                      <div className="flex items-center gap-1.5 text-emerald-700 bg-emerald-50 px-2 py-1 rounded text-xs border border-emerald-100 w-fit">
                        <FileText size={12} />
                        <span className="font-medium">{shop.businessRegistrationNumber}</span>
                      </div>
                    ) : (
                      <span className="text-xs text-slate-400 italic bg-slate-50 px-2 py-1 rounded">
                        Chưa đăng ký
                      </span>
                    )}
                  </td>

                  {/* Cột 5: Chủ sở hữu */}
                  <td className="px-6 py-4 align-top">
                    <div className="flex items-center gap-2">
                      <div className="h-6 w-6 rounded-full bg-slate-100 flex items-center justify-center text-slate-500 text-xs font-bold shrink-0">
                        <User size={12} />
                      </div>
                      <span className="text-sm font-medium text-slate-700 line-clamp-1" title={shop.userName}>
                        {shop.userName}
                      </span>
                    </div>
                  </td>

                  {/* Cột 6: Actions */}
                  <td className="px-4 py-4 align-middle text-center">
                    <button
                      onClick={(e) => {
                        e.stopPropagation();
                        onRowClick(shop);
                      }}
                      className="p-2 bg-white border border-slate-200 text-slate-400 hover:text-blue-600 hover:border-blue-200 hover:bg-blue-50 rounded-lg transition-all shadow-sm opacity-100 sm:opacity-0 sm:group-hover:opacity-100"
                      title="Xem chi tiết"
                    >
                      <Eye size={16} />
                    </button>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="6" className="px-6 py-16 text-center text-slate-500">
                  <div className="flex flex-col items-center justify-center">
                    <div className="bg-slate-100 p-4 rounded-full mb-3">
                      <Search className="h-8 w-8 text-slate-400" />
                    </div>
                    <p className="text-base font-medium text-slate-900">Không tìm thấy kết quả</p>
                    <p className="text-sm mt-1">Vui lòng thử lại với từ khóa khác.</p>
                  </div>
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default WorkspaceTable;